import hoistNonReactStatics from 'hoist-non-react-statics';
import React from 'react';
import { useStore } from 'react-redux';

/**
 * Supplies the current Redux store to class components without coupling them
 * to React Redux's context value shape.
 */
export default function withStore(WrappedComponent) {
  const StoreInjector = React.forwardRef((props, ref) => {
    const store = useStore();
    return <WrappedComponent {...props} ref={ref} reduxStore={store} />;
  });

  StoreInjector.displayName = `withStore(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  StoreInjector.WrappedComponent = WrappedComponent;

  return hoistNonReactStatics(StoreInjector, WrappedComponent);
}
